import {
  IconArmchair,
  IconBook2,
  IconBrandInstagram,
  IconBrush,
  IconBuildingStore,
  IconTimeline,
  IconLayout,
  IconMasksTheater,
  IconMovie,
  IconPalette,
  IconPuzzle,
  IconRobot,
  IconSpeakerphone,
  IconWriting,
} from '@tabler/icons-react';
import { createStyles, cx } from 'antd-style';
import type { CSSProperties } from 'react';

const CATEGORY_ICONS = {
  script: IconWriting,
  manual: IconBook2,
  production: IconTimeline,
  agent_core: IconRobot,
  style: IconPalette,
  visual_style: IconPalette,
  genre: IconMasksTheater,
  custom: IconPuzzle,
};

const BUILTIN_ICONS = {
  general: IconRobot,
  drama: IconMovie,
  ecommerce: IconBuildingStore,
  poster: IconLayout,
  brand: IconBrush,
  interior: IconArmchair,
  social: IconBrandInstagram,
  marketing_video: IconSpeakerphone,
  viral_clone: IconMovie,
};

const useStyles = createStyles(({ token, css }) => ({
  icon: css`
    display: inline-flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    border-radius: ${token.borderRadiusLG}px;
    background: ${token.colorFillTertiary};
    color: ${token.colorTextSecondary};
    vertical-align: middle;
    svg { width: 54%; height: 54%; }
  `,
}));

export interface SkillIconProps {
  skillId?: string;
  category?: string;
  size?: number;
  className?: string;
  style?: CSSProperties;
}

export default function SkillIcon({
  skillId,
  category,
  size = 40,
  className,
  style,
}: SkillIconProps) {
  const { styles } = useStyles();
  const Icon =
    BUILTIN_ICONS[skillId as keyof typeof BUILTIN_ICONS] ||
    CATEGORY_ICONS[category as keyof typeof CATEGORY_ICONS] ||
    IconPuzzle;
  return (
    <span
      aria-hidden="true"
      className={cx(styles.icon, className)}
      style={{ width: size, height: size, ...style }}
    >
      <Icon stroke={1.7} />
    </span>
  );
}
